var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCoin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 512,
    height: 512,
    x: 0,
    y: 0,
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    className: "",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#fe9923",
    fillRule: "evenodd",
    d: "M132.188 323.567c0-37.318 84.902-67.596 189.67-67.596 104.739 0 189.641 30.279 189.641 67.596v62.128c0 37.318-84.902 67.596-189.641 67.596-104.768 0-189.67-30.279-189.67-67.596v-62.128z",
    clipRule: "evenodd",
    opacity: 1,
    "data-original": "#fe9923",
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fecd3d",
    fillRule: "evenodd",
    d: "M321.859 255.971c104.739 0 189.641 30.279 189.641 67.596 0 37.346-84.902 67.596-189.641 67.596-104.768 0-189.67-30.249-189.67-67.596-.001-37.318 84.902-67.596 189.67-67.596z",
    clipRule: "evenodd",
    opacity: 1,
    "data-original": "#fecd3d",
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fea832",
    fillRule: "evenodd",
    d: "M321.859 287.558c83.332 0 150.87 16.143 150.87 36.009 0 19.895-67.538 36.008-150.87 36.008S170.96 343.461 170.96 323.567c0-19.866 67.567-36.009 150.899-36.009z",
    clipRule: "evenodd",
    opacity: 1,
    "data-original": "#fea832",
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#c85929",
    d: "m225.846 415.508 16.201.029v31.471a358.184 358.184 0 0 1-16.201-3.025zm234.375-16.666v33.071c5.846-2.24 11.256-4.595 16.23-7.068v-26.032zm-175.796 53.111c5.352.407 10.762.698 16.23.902V422.78l-16.23.029zm-117.188-27.108c4.974 2.473 10.384 4.828 16.23 7.068v-33.1l-16.23.029zm175.796 28.01a478.526 478.526 0 0 0 16.201-.902v-29.144l-16.201-.029zm58.609-5.847a350.788 350.788 0 0 0 16.201-3.025v-28.446l-16.201-.029z",
    opacity: 1,
    "data-original": "#c85929",
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fea832",
    d: "M56.186 398.667v20.128h20.099v14.368H56.186v20.128H41.818v-20.128H21.69v-14.368h20.128v-20.128zM423.893 178.224v20.127h20.127v14.34h-20.127v20.127h-14.369v-20.127h-20.098v-14.34h20.098v-20.127zM65.843 58.709v20.128h20.099v14.339H65.843v20.128H51.474V93.176H31.347V78.837h20.127V58.709z",
    opacity: 1,
    "data-original": "#fea832",
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fe9923",
    fillRule: "evenodd",
    d: "M3.977 288.431c-18.673-32.344 39.732-101.016 130.451-153.371 90.72-52.384 179.374-68.614 198.047-36.3a88642.46 88642.46 0 0 0 31.064 53.78c18.673 32.344-39.732 101.016-130.451 153.371-90.719 52.384-179.374 68.643-198.047 36.299-10.355-17.916-20.709-35.862-31.064-53.779z",
    clipRule: "evenodd",
    opacity: 1,
    "data-original": "#fe9923",
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fecd3d",
    fillRule: "evenodd",
    d: "M134.428 135.06c90.72-52.384 179.374-68.614 198.047-36.3 18.673 32.344-39.732 101.016-130.451 153.371-90.69 52.384-179.374 68.614-198.047 36.299-18.673-32.343 39.732-101.015 130.451-153.37z",
    clipRule: "evenodd",
    opacity: 1,
    "data-original": "#fecd3d",
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fea832",
    fillRule: "evenodd",
    d: "M150.222 162.401c72.163-41.651 138.741-61.459 148.688-44.24s-40.517 64.949-112.679 106.63c-72.163 41.651-138.712 61.459-148.659 44.24s40.487-64.95 112.65-106.63z",
    clipRule: "evenodd",
    opacity: 1,
    "data-original": "#fea832",
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#c85929",
    d: "m199.494 290.118 15.038 26.032a450.07 450.07 0 0 1-14.514 7.329l-14.572-25.246zM71.98 336.074l13.002 22.512c5.526-.32 11.402-.989 17.568-1.978l-16.521-28.649zm59.074-14.863 14.252 24.665a372.254 372.254 0 0 0 15.532-5.468l-15.736-27.283zM236.2 268.914l15.038 26.032a473.657 473.657 0 0 0 13.583-8.871l-14.572-25.218zm103.547-87.462-14.049 8.144 16.55 28.621c3.927-4.828 7.446-9.599 10.5-14.224zm-56.427 51.861 15.736 27.283a337.297 337.297 0 0 0 12.507-10.704l-14.223-24.636z",
    opacity: 1,
    "data-original": "#c85929",
    className: ""
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCoin);
export default __webpack_public_path__ + "static/media/coin.c1a34c38eab49cf59e323321667a5aee.svg";
export { ForwardRef as ReactComponent };